import React from 'react';
import classNames from 'classnames';
import { RadioButtonProps } from '@lib/components/RadioButton/RadioButton';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import { colorToChipType } from '@lib/components/Chip/utils/colorEnum';
import styles from './RadioButtonAsChipColor.module.scss';

function RadioButtonAsChipColor(props: RadioButtonProps & { color?: string }) {
  const { id, checked, color, onChange } = props;

  const onClick = (e: unknown) => {
    const v = e as React.ChangeEvent<HTMLInputElement>;
    onChange(v);
  };

  // The swatch uses the `color` (`chip-*`) prop so the option `value` can carry
  // the `ColorEnum` (e.g. `BLUE`); when absent, resolve the `id` to its class.
  const colorClass = color || colorToChipType(`${id}`);

  return (
    <button
      type="button"
      className={classNames(
        styles.root,
        styles[colorClass],
        styles.smallLeftIconOnly,
        {
          [styles.checked]: checked,
        },
      )}
      onClick={onClick}
    >
      <MaterialIcon
        icon={checked ? 'check_circle' : 'circle'}
        className={styles.leftIcon}
      />
    </button>
  );
}

export default RadioButtonAsChipColor;
